import React from "react";
import { motion } from "framer-motion";
import "./index.css"; // Optional: For styling purposes

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <motion.div className="modal-background" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }} exit={{ opacity: 0 }}>
          <motion.div className="modal-content" initial={{ scale: 0.5 }} animate={{ scale: 1 }} transition={{ duration: 0.3 }}>
            <div className="modal-body">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </>
  );
};

export default Modal;
